import { apiCall } from './ApiCall';

export const getAllGenre_Contacts = ({ cursor, limit } = {}) => apiCall("getallgenre_contacts")